import React, { useReducer, useState, useEffect, createContext } from "react"
import Drawer from "@convertkit/design/drawer"
import useFetch from "hooks/use-new-fetch"

import Changelog from "./changelog"
import Button from "./button"
import DrawerHeading from "./drawer-heading"

const DiscoveryHubContext = createContext()

export default function DiscoveryHub() {
  const discoveryHubState = {
    notificationCounter: 0
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case "setNotificationCounter":
        return {
          ...state,
          notificationCounter: action.count
        }
      case "decrementNotificationCounter":
        return {
          ...state,
          notificationCounter: state.notificationCounter - 1
        }
      case "setNotificationCounterToZero":
        return {
          ...state,
          notificationCounter: 0
        }
    }
  }

  const [state, dispatch] = useReducer(reducer, discoveryHubState)
  const [drawerActive, setDrawerActive] = useState(false)
  const toggleDrawer = () => setDrawerActive(!drawerActive)
  const [request] = useFetch("/onboarding/changelog_items/notification_count")

  useEffect(() => {
    const fetchData = async () => {
      const response = await request.get({ path: "/" })
      dispatch({ type: "setNotificationCounter", count: response.data })
    }

    fetchData()
  }, [])

  const hubContext = {
    notificationCounter: state.notificationCounter,
    decrementNotificationCounter: () => {
      dispatch({ type: "decrementNotificationCounter" })
    },
    setNotificationCounterToZero: () => {
      dispatch({ type: "setNotificationCounterToZero" })
    }
  }

  return (
    <DiscoveryHubContext.Provider value={hubContext}>
      <div>
        <Button is="secondary" toggleDrawer={toggleDrawer} />
      </div>

      {drawerActive && (
        <Drawer heading={<DrawerHeading />} onClose={toggleDrawer}>
          <Changelog />
        </Drawer>
      )}
    </DiscoveryHubContext.Provider>
  )
}

export { DiscoveryHubContext }
